import { AdminGuardService } from './../../servicios/guards/admin-guard.service';
import { Component, ElementRef, Input, OnInit, ViewChild, DoCheck } from '@angular/core';
import {MatSort, MatTableDataSource, MatDialog} from '@angular/material';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";
import { AuthService } from '../../servicios/auth.service';
import { UserGuardService } from '../../servicios/guards/user-guard.service';
import { MultiUserGuardService } from '../../servicios/guards/multi-user.service';
import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
import { read } from 'cfb/types';
//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';

//ngx-webcam 1
import {Subject} from 'rxjs';
import {Observable} from 'rxjs';
import {WebcamImage, WebcamInitError, WebcamUtil} from 'ngx-webcam';
import { environment } from "environments/environment";



@Component({
  selector: 'app-contador',
  templateUrl: './contador.component.html',
  styleUrls: ['./contador.component.css']
})
export class ContadorComponent implements OnInit, DoCheck {
@ViewChild('REPORTE') reporte: ElementRef;
loading;
dataSourceReporte = new MatTableDataSource();
dateValue: any;
dateValue2: any;
selectedDate;
selectedDate2;
fecha_ticket;
fecha_ticket2;
control=false;

  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    //snackbar 2
    public snackBar: MatSnackBar
  ) { 
    this.loading=false;
  }

  ngDoCheck(){
    //para habilitar boton
    if ((!this.fecha_ticket) || (!this.fecha_ticket2)){
      this.control=false;
      console.log("fechas inc..");
    }else{
      this.control=true;
      console.log("fechas ok!");
    }
    console.log("CONTROL:" + this.control);
  
    //para cerrar modal si termina el loading
    if (this.loading==true){
    }else{
      document.getElementById("salemodal").click(); 
    }
  }
  onActivate(event) {
    window.scroll(0,0);
    //or document.body.scrollTop = 0;
    //or document.querySelector('body').scrollTo(0,0)
  }

  ngOnInit() {
  }

  //mandioca2019 (exporta datasource)
  exportExcel(data: any[]){
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, `ReporteCuentas_${this.fecha_ticket}_${this.fecha_ticket2}.xls`, { bookType: 'xls', type: 'buffer' });
 }

  exportAsExcelReporte() {
    console.log("Generando reporte..");
    this.exportExcel(this.dataSourceReporte.data);
  }

  addEvent( input: string, $event ) {
    this.selectedDate = moment($event.value).format('YYYY-MM-DD');
    this.fecha_ticket=this.selectedDate;
    moment(this.fecha_ticket).format('YYYY-MM-DD')
    console.log("fecha desde:" + this.fecha_ticket);
  }

  addEvent2( input: string, $event ) {
    this.selectedDate2 = moment($event.value).format('YYYY-MM-DD');
    this.fecha_ticket2=this.selectedDate2;
    moment(this.fecha_ticket2).format('YYYY-MM-DD')
    console.log("fecha hasta:" + this.fecha_ticket2);
  }

  getRepo(){
    this.loading=true;
    //http://localhost:1337/api/contador/repo?fdes=2018-01-01&fhas=2019-01-01
    this.http.get(`${environment.backendUrl}/api/contador/repo?fdes=${this.fecha_ticket}&fhas=${this.fecha_ticket2}`)
    .subscribe((datos: any[]) => {
      if (datos){
        console.log("fechas con datos!");
        this.dataSourceReporte.data = datos[0];
        console.warn(this.dataSourceReporte.data);
        this.exportAsExcelReporte();
        this.loading=false;
      }else{
        console.log("fechas sin datos..");
        this.loading=false;
      }
    });
  }


}
